import { Menu } from "@mui/icons-material";
import { IconButton } from "@mui/material";

const MenuButton = ({
  handleDrawerToggle,
  drawerWidth,
  theme,
  isDrawerOpen,
}) => {
  return (
    <IconButton
      onClick={handleDrawerToggle}
      sx={{
        position: "fixed",
        left: drawerWidth - 20,
        top: 32,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        transform: isDrawerOpen ? "none" : "rotate(180deg)",
        transition: "all 0.2s",
        "&:hover": {
          backgroundColor: theme.palette.primary.dark,
        },
        zIndex: 1200,
        boxShadow: "0px 0px 6px 6px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Menu />
    </IconButton>
  );
};

export default MenuButton;
